import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEllipse = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 8,
	fill: "currentColor",
	viewBox: "0 0 8 8",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 4,
		cy: 4,
		r: 4
	})
});
export default SvgEllipse;
